import React from "react";
import {
    Navigate,
} from "react-router-dom";

const QuotationListComponent = React.lazy(() => import("../../../../../components/stk-quotation/components/list/page"));
const QuotationAddComponent = React.lazy(() => import("../../../../../components/stk-quotation/components/add/page"));
const QuotationShowComponent = React.lazy(() => import("../../../../../components/stk-quotation/components/show/page"));

export const quotationRoutes = [
    {
        path: 'list',
        element: <QuotationListComponent />
    },
    {
        path: 'add',
        element: <QuotationAddComponent />
    },
    {
        path: 'edit',
        element: <Navigate to="/stockify/quotation/add" />
    },
    {
        path: 'edit/:id',
        element: <QuotationAddComponent />
    },
    {
        path: 'show/:id',
        element: <QuotationShowComponent />
    },
    {
        path: '',
        element: <Navigate replace to="/stockify/quotation/list" />
    },
];